/* eslint-disable */
import axios from 'axios';

const apiAi = axios.create({
  baseURL: process.env.REACT_APP_API_AI,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json; charset=utf-8',
    //'Access-Control-Allow-Origin': '*',
  },
});

export default apiAi;
